// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.contentslider {
    position: absolute; /* Position the background text */
    bottom: 0; /* At the bottom. Use top:0 to append it to the top */
    background: rgb(0, 0, 0); /* Fallback color */
    background: rgba(0, 0, 0, 0.5); /* Black background with 0.5 opacity */
    color: #f1f1f1; /* Grey text */
    width: 100%; /* Full width */
    padding: 25px;
}

.slick-arrow{
    z-index:1000 !important;
}
.slide-content{
    height: 100%;
}
.ArrowPrev{
    position: absolute;
    left: 0;
    z-index: 1;
    cursor:pointer;
}
.ArrowNext {
    position: absolute;
    right: 0;
    z-index: 1000;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/components/controls/carousel/carousel.control.css"],"names":[],"mappings":";AACA;IACI,kBAAkB,EAAE,iCAAiC;IACrD,SAAS,EAAE,qDAAqD;IAChE,wBAAwB,EAAE,mBAAmB;IAC7C,8BAA8B,EAAE,sCAAsC;IACtE,cAAc,EAAE,cAAc;IAC9B,WAAW,EAAE,eAAe;IAC5B,aAAa;AACjB;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,eAAe;AACnB","sourcesContent":["\n.contentslider {\n    position: absolute; /* Position the background text */\n    bottom: 0; /* At the bottom. Use top:0 to append it to the top */\n    background: rgb(0, 0, 0); /* Fallback color */\n    background: rgba(0, 0, 0, 0.5); /* Black background with 0.5 opacity */\n    color: #f1f1f1; /* Grey text */\n    width: 100%; /* Full width */\n    padding: 25px;\n}\n\n.slick-arrow{\n    z-index:1000 !important;\n}\n.slide-content{\n    height: 100%;\n}\n.ArrowPrev{\n    position: absolute;\n    left: 0;\n    z-index: 1;\n    cursor:pointer;\n}\n.ArrowNext {\n    position: absolute;\n    right: 0;\n    z-index: 1000;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
